import * as React from 'react';
import ServiceSummaryDivider from '../components/ServiceSummaryDivider/ServiceSummaryDivider';
import ServiceSummaryOption from '../components/ServiceSummaryOption';
import { ServiceSummaryOptionsType } from '../types';

interface Props {
	options: ServiceSummaryOptionsType[];
}

const LoyaltySummary: React.FC<Props> = props => {
	return (
		<ServiceSummaryDivider>
			{props.options.map(option => (
				<ServiceSummaryOption
					groupOption={{
						header: option.header,
						items: option.items
					}}
				/>
			))}
		</ServiceSummaryDivider>
	);
};

export default LoyaltySummary;
